// extracted by mini-css-extract-plugin
module.exports = {"info":"UserModule_info__Bd_QS","main":"UserModule_main__23yVc","tableSmall":"UserModule_tableSmall__EcU0Z"};